import { NativeStackScreenProps } from '@react-navigation/native-stack';

export interface AccountsTransfersModalProps {
  onLayout: (event: any) => void;
}

export enum AccountsTransfersStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed',
  AccountSelect = 'AccountSelect'
}

export type AccountsTransfersStackParamList = {
  [AccountsTransfersStackRoutes.Main]: AccountsTransfersModalProps & {
    account: string;
    tab?: number;
    record?: any;
    onData: (data: any) => void;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [AccountsTransfersStackRoutes.Confirm]: AccountsTransfersModalProps & {
    account: string;
    tab?: number;
    record?: any;
    data: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [AccountsTransfersStackRoutes.Placed]: AccountsTransfersModalProps & {
    account: string;
    tab?: number;
    record?: any;
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
  [AccountsTransfersStackRoutes.AccountSelect]: AccountsTransfersModalProps & {
    asset?: any;
    otherSelectedId?: string;
    onSelect: (walletId: string, wallet?: any) => void;
    onChangeView?: () => void;
    subaccountFlag?: boolean;
    balanceAllFlag?: boolean;
  };
};

export type AccountsTransfersStackScreenProps<Screen extends keyof AccountsTransfersStackParamList> = NativeStackScreenProps<
  AccountsTransfersStackParamList,
  Screen
>;
